// Modal "¿Qué vas a cargar?" — atajo del encargado desde la sección "Por cargar".
// Elige entre Agencia (carga continua de todos los pedidos por agencia) o
// Camión/Gira (elegir el viaje que sale). Mismos destinos que la pantalla
// ColaDespacho, pero como modal para no salir del tablero.

import React from "react";
import { useNavigate } from "react-router-dom";

export default function CargarCamionModal({ agenciaCount = 0, camionGiraCount = 0, onClose }) {
  const navigate = useNavigate();
  const opciones = [
    {
      id: "AGENCIA", icon: "🚌", title: "Agencia",
      subtitle: "Escaneo continuo de todos los pedidos, por agencia",
      href: "/encargado/control-carga", count: agenciaCount, countLabel: "para cargar",
      color: "#1d4ed8", bg: "#eff6ff",
    },
    {
      id: "CAMION", icon: "🚚", title: "Camión / Gira",
      subtitle: "Elegí el viaje que sale y cargá sus pedidos",
      href: "/encargado/camiones", count: camionGiraCount, countLabel: "para cargar",
      color: "#15803d", bg: "#f0fdf4",
    },
  ];

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1000, display: "flex", alignItems: "flex-end" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", width: "100%", borderRadius: "16px 16px 0 0", padding: "18px 16px 28px", maxHeight: "80vh", overflowY: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 800 }}>🚚 ¿Qué vas a cargar?</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: "24px", cursor: "pointer", color: "#94a3b8", lineHeight: 1 }}>×</button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {opciones.map(o => (
            <button key={o.id} onClick={() => navigate(o.href)}
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", background: o.bg, border: `1.5px solid ${o.color}33`, borderRadius: "14px", padding: "16px 18px", cursor: "pointer", textAlign: "left", width: "100%" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ fontSize: "28px", lineHeight: 1 }}>{o.icon}</span>
                <div>
                  <div style={{ fontWeight: 800, fontSize: "15px", color: "#0f172a" }}>{o.title}</div>
                  <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>{o.subtitle}</div>
                  {o.count > 0 && (
                    <div style={{ marginTop: "5px" }}>
                      <span style={{ fontSize: "12px", fontWeight: 700, color: o.color, background: "#fff", border: `1px solid ${o.color}55`, padding: "2px 9px", borderRadius: "999px" }}>
                        {o.count} {o.countLabel}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <span style={{ fontSize: "20px", color: o.color, flexShrink: 0 }}>›</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
